const administratorOnlyIntegrationSlugs = new Set([
    'criteo',
    'tiktok',
    'google-merchant',
    'google-analytics',
    'google-search-console',
    'google-bigquery',
]);

export function isAdministratorOnlyBrand(brand) {
    return administratorOnlyIntegrationSlugs.has(brand?.slug)
        || brand?.slug === 'mysql';
}

export function isBrandVisibleToUser(brand, isAdministrator, hasExistingIntegration = false) {
    // The old Upgates XML integration is deprecated and no longer surfaced in the UI.
    if (brand?.slug === 'upgates' && brand?.isLegacyXml === true) return false;

    return !isAdministratorOnlyBrand(brand) || isAdministrator === true;
}
